import { Business, CustomerCategory, CustomerSubCategory, Product } from '../types';

const isProduct = (category: CustomerCategory | CustomerSubCategory | Product): category is Product => {
  return (category as Product).post_name !== undefined;
};

const isBusiness = (partner: string): partner is Business => {
  return Object.values(Business).includes(partner as Business);
};

export { isBusiness, isProduct };
